<template>
  <div data-qa="noticecashisaselectpayaway-div-rz55w">
    <v-tabs
      v-model="selectedBankType"
      :color="primaryColor"
      @change="handleAccountTypeChange"
      data-qa="noticecashisaselectpayaway-tabs-rh0209">
      <v-tab class="text-capitalize font-weight-bold"  data-qa="noticecashisaselectpayaway-tab-lyei1s">
        {{ $t("termDepositActions.listAC.internalButtonLabel") }}
      </v-tab>
      <v-tab class="text-capitalize font-weight-bold"  data-qa="noticecashisaselectpayaway-tab-31u9rp">
        {{ $t("termDepositActions.listAC.externalButtonLabel") }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedBankType" data-qa="noticecashisaselectpayaway-tabs-items-fa1qa">
      <v-tab-item v-for="(n, i) in 2" :key="n" :data-qa="`noticecashisaselectpayaway-tab-item-fa2qa-${i}`">
        <v-autocomplete
          v-model="selectedPayaway"
          class="pt-6"
          :items="items"
          label="Payaway account"
          :color="primaryColor"
          :rules="[rules.required]"
          return-object
          :hint="selectedPayaway?.hint"
          persistent-hint
          :data-qa="`noticecashisaselectpayaway-autocomplete-ukvs8m-${i}`">
          <template v-slot:item="data">
            <v-list-item-content :data-qa="`noticecashisaselectpayaway-list-item-content-ogkqlx-${i}`">
              {{ data.item.primaryLine }}
              <v-list-item-subtitle :data-qa="`noticecashisaselectpayaway-list-item-subtitle-qkcp-${i}`"
                v-text="data.item.secondaryLine"
              />
              <v-divider :data-qa="`noticecashisaselectpayaway-divider-2zc375-${i}`"  />
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { formatPrimaryLine, formatSecondaryLine, formatSelectedAccount, formatSelectedHint } from '../../../../util/accountUtil'
export default {
  name: 'NoticeCashIsaSelectPayaway',
  props: {
    value: {
      validator: function (value) {
        return value === null || typeof value === 'object'
      }
    },
    sameBankAccounts: {
      type: Array,
      required: true
    },
    otherBankAccounts: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedBankType: 0,
      excludedAccountStatus: ['DORMANT', 'DEACTIVATED', 'INACTIVE', 'BLOCKED', 'STOPPED', 'CLOSED'],
      excludedAriStatus: ['REFREPOST', 'REFREPOSTENQ', 'CREDIT', 'DEBIT', 'REFREDR', 'REFRECR', 'DEBITCREDIT', 'ACCSTOPENQ', 'REFREPOSTNOREFENQ', 'ACCSTOPENQWITHREF'],
      enableNominatedAccountFeatures: this.$appSettings.defaultConfigurations.nominatedAccounts.enableNominatedAccountFeatures,
      accountLabel: this.$t('common.account'),
      allowInactiveAccountTransactionalOperations: this.$appSettings.defaultConfigurations.allowInactiveAccountTransactionalOperations,
      rules: {
        required: (v) => Boolean(v) || 'Required'
      }
    }
  },
  methods: {
    handleAccountTypeChange () {
      this.selectedPayaway = null
      this.$emit('input', null)
    },
    include ({ accountId, postingsRestriction, accountStatus, accountType }) {
      return accountId !== this.$route.params.accountId &&
        !this.excludedAriStatus.includes(postingsRestriction) &&
        !this.excludedAccountStatus.includes(accountStatus) &&
        (accountType == null || this.allowedPayawayAccountType.includes(accountType))
    }
  },
  computed: {
    selectedPayaway: {
      get () {
        return this.value
      },
      set (newValue) {
        if (newValue) {
          const emittedValue = {
            ...newValue,
            payAwayaccount: newValue.value,
            payAwayaccountText: newValue.text,
            otherBankAccount: this.isSameBankSelected ? 'NO' : 'YES',
            payawayBeneficiaryId: newValue.beneficiaryId
          }
          this.$emit('input', emittedValue)
        } else {
          this.$emit('input', null)
        }
      }
    },
    isSameBankSelected () {
      return this.selectedBankType === 0
    },
    items () {
      return this.isSameBankSelected ? this.computedSameBanks : this.computedOtherBanks
    },
    computedSameBanks () {
      return this.sameBankAccounts
        .filter(account => this.include(account))
        .map(account => ({
          ...account,
          primaryLine: formatPrimaryLine(account),
          secondaryLine: formatSecondaryLine(account),
          text: formatSelectedAccount(account),
          hint: formatSelectedHint(account),
          value: account.accountId,
          beneficiaryId: null
        }))
    },
    computedOtherBanks () {
      return this.otherBankAccounts
        .filter(account => this.include(account) && (!this.enableNominatedAccountFeatures || account.ownAccount))
        .map(account => ({
          ...account,
          primaryLine: account.name,
          secondaryLine: `${account.accountIdentification} - ${account.bankIdentifier}`,
          text: account.name,
          hint: `${account.accountIdentification} - ${account.bankIdentifier}`,
          value: account.beneficiaryId,
          beneficiaryId: account.beneficiaryId
        }))
    },
    allowedPayawayAccountType () {
      return this.isNoticeAccount
        ? this.$appSettings.defaultConfigurations.noticeAccountClosure.allowedPayawayAccountType
        : this.$appSettings.defaultConfigurations.noticeCashIsa.closeAccount.allowedPayawayAccountType
    },
    isNoticeAccount () {
      return this.$route.params.accountType === 'NACC'
    }
  },
  created () {
    if (this.allowInactiveAccountTransactionalOperations) {
      const index = this.excludedAccountStatus.indexOf('INACTIVE')
      this.excludedAccountStatus.splice(index, 1)
    }
    this.selectedBankType = this.value?.otherBankAccount === 'YES' ? 1 : 0
  }
}
</script>
